import { render, staticRenderFns } from "./cancellation-feedback.vue?vue&type=template&id=6254ebac&scoped=true"
import script from "./cancellation-feedback.vue?vue&type=script&lang=js"
export * from "./cancellation-feedback.vue?vue&type=script&lang=js"
import style0 from "./cancellation-feedback.vue?vue&type=style&index=0&id=6254ebac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6254ebac",
  null
  
)

export default component.exports